import { createFileRoute } from '@tanstack/react-router';
import { Layers } from 'lucide-react';
import { useMemo } from 'react';
import type { TaskScope } from '@/features/tasks/api';
import { TaskViewPage } from '@/features/tasks/task-view-page';

export const Route = createFileRoute('/w/$workspaceId/everything')({ component: EverythingPage });

/** Every task in the workspace the user can see, with the same saved views as any list. */
function EverythingPage() {
  const { workspaceId } = Route.useParams();
  const scope = useMemo<TaskScope>(() => ({ type: 'everything', id: workspaceId }), [workspaceId]);
  return <TaskViewPage scope={scope} title="Everything" icon={<Layers />} />;
}
